import { Button, Divider, Image, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { options } from '../../constants/reviewRatings';
import styles from './ReviewQuestionItem.module.css';

const cx = classnames.bind(styles);

export default function ReviewQuestionItem({ item, onScoreChosen }) {
  const { t } = useTranslation(['review', 'miscellaneous']);

  const handleOptionClicked = (e, optionValue) => {
    if (e) { e.preventDefault(); }
    onScoreChosen(item.id, optionValue);
  };

  return (
    <Fragment>
      <Text>{item.question}</Text>
      <br />
      <br />
      <div className={cx('ratingOptions')}>
        {options.map(({ key, icon, value }) => (
          <Fragment key={value}>
            <div
              role="button"
              tabIndex="0"
              className={cx('ratingOption')}
              onClick={() => { handleOptionClicked(null, value); }}
              onKeyUp={() => { handleOptionClicked(null, value); }}
              onKeyDown={() => { handleOptionClicked(null, value); }}
            >
              <Image src={icon} className={cx('icon')} alt={t(`${key}Icon`, { ns: 'review' })} />
              <Text as="p">
                {t(key, { ns: 'review' })}
              </Text>
            </div>
            <div className={cx('dividerContainer')}>
              <Divider vertical />
            </div>
          </Fragment>
        ))}
        <div className={cx('ratingOption')}>
          <Button
            link
            fluid
            onClick={(e) => { handleOptionClicked(e, 0); }}
          >
            {t('actions.notSure', { ns: 'miscellaneous' })}
          </Button>
        </div>
      </div>
    </Fragment>
  );
}

ReviewQuestionItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    question: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
  }).isRequired,
  onScoreChosen: PropTypes.func.isRequired,
};
